module.exports = __webpack_public_path__ + "static/media/telefonica@3x.6cb82430.png";